// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-right.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-right',
  version: 'outline',
  paths: [
    {
      d: 'M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3',
    },
  ],
}
